import { Entity, PrimaryColumn, Column } from 'typeorm';
import { IndividualReportForOffline, InspectionReport } from '../../_objects/inspection-report';
import { SubjectFilter } from '../../_services/storage.service';
import { BaseSchema } from '../abstracts/base.schema';

@Entity()
export class IndividualReportSchema extends BaseSchema {
  @PrimaryColumn()
    id: string;

  @Column({ nullable: true })
    reportId: string | null;

  @Column({ nullable: true })
    title: string | null;

  @Column({ nullable: true })
    version: number | null;

  @Column({ nullable: true })
    inspectionId: string | null;

  @Column({ nullable: true })
    isNewestVersion: boolean | null;

  @Column({ nullable: true })
    templateId: string | null;

  @Column({ nullable: true })
    status: string | null;

  @Column({ nullable: true })
    editableTexts: string | null;

  @Column({ nullable: false, default: '[]' })
    excludedInputGroups: string | null;

  @Column({ nullable: true })
    reportLocations: string | null;

  @Column({ nullable: true })
    blobStorageAccount: string | null;

  @Column({ nullable: true })
    isValid: boolean | null;

  @Column({ nullable: true })
    schemaVersion: string | null;

  @Column({ nullable: true })
    isDeleted: boolean | null;

  @Column({ nullable: true })
    imagePathList: string | null;

  @Column({ nullable: true })
    createDate: string | null;

  @Column({ nullable: true })
    lastUpdateDate: string | null;

  @Column({ nullable: true })
    rowVersion: string | null;

  @Column({ nullable: true })
    isAutoInputTitle: boolean | null;

  @Column({ nullable: true })
    type: string | null;

  @Column({ nullable: true })
    manageUserId: string | null;

  @Column({ nullable: true, default: null })
    thumbFilePath: string | null;

  @Column({ nullable: true, default: null })
  finalReportTitle: string | null;

  @Column({ nullable: true, default: null })
    draftReportQuality: number | null;

  @Column({ nullable: true, default: null })
    finalReportQuality: number | null;

  setIndividualReportForOffline(report: IndividualReportForOffline, userId: string) {
    this.id = report.id;
    this.reportId = report.reportId;
    this.title = report.title;
    this.version = report.version;
    this.inspectionId = report.inspectionIds[0];
    this.isNewestVersion = report.isNewestVersion;
    this.templateId = report.templateId;
    this.status = report.status;
    this.editableTexts = JSON.stringify(report.editableTexts);
    this.excludedInputGroups = JSON.stringify(report.excludedInputGroups);
    this.reportLocations = JSON.stringify(report.reportLocations);
    this.blobStorageAccount = report.blobStorageAccount;
    this.isValid = report.isValid;
    this.schemaVersion = report.schemaVersion;
    this.isDeleted = report.isDeleted;
    this.imagePathList = null;
    this.createDate = report.createDate;
    this.lastUpdateDate = report.lastUpdateDate;
    this.isAutoInputTitle = false;
    this.type = report.type;
    this.manageUserId = userId;
    this.draftReportQuality = report.draftReportQuality;
    this.finalReportQuality = report.finalReportQuality;
    this.finalReportTitle = report.finalReportTitle ?? null;
  }

  setInspectionReport(report: InspectionReport, tenantId: string, isNewestVersion: boolean, userId: string, thumbFilePath: string) {
    this.id = report.id;
    this.reportId = report.reportId;
    this.title = report.title;
    this.version = report.version;
    this.inspectionId = report.inspectionIds[0];
    this.isNewestVersion = isNewestVersion;
    this.templateId = report.templateId;
    this.status = report.status;
    this.editableTexts = JSON.stringify(report.editableTexts);
    this.excludedInputGroups = JSON.stringify(report.excludedInputGroups);
    this.reportLocations = JSON.stringify(report.reportLocations);
    this.blobStorageAccount = report.blobStorageAccount;
    this.isValid = true;
    this.schemaVersion = report.schemaVersion;
    this.isDeleted = false;
    this.imagePathList = null;
    this.createdBy = report.createdBy;
    this.createDate = report.createDate;
    this.lastUpdatedBy = report.lastUpdatedBy;
    this.lastUpdateDate = report.lastUpdateDate;
    this.isAutoInputTitle = report.isAutoInputTitle;
    this.type = 'individual';
    this.tenantId = tenantId;
    this.manageUserId = userId;
    this.thumbFilePath = `inspections\\${this.inspectionId}\\reports\\${this.reportId}\\thumbnail-${this.version}.png`;
  }
}

export class IndividualReportQueryOpt {
  tenantId: string;
  inspectionId: string;
  userId: string;
  status: string;
  subjectFilter: SubjectFilter;
  isOwn: boolean;
  sort?: { active: string; direction: string; };
  isNewestOnly: boolean;

  constructor(tenantId: string, userId: string, inspectionId: string, statusCode?: string, subjectFilter?: SubjectFilter,
    isOwn?: boolean, sort?: { active: string; direction: string; }, isNewestOnly?: boolean) {
    this.tenantId = tenantId;
    this.inspectionId = inspectionId;
    this.userId = userId;
    this.status = statusCode;
    this.subjectFilter = subjectFilter;
    this.isOwn = isOwn;
    this.sort = sort;
    this.isNewestOnly = isNewestOnly;
  }
}
